import './SelectList.sass';

import React, { FC } from 'react';

import { SelectListProps } from '$uikit/SelectList/SelectList.interface';
import { List, ListItem } from '$uikit';
import { IcRadioButton24, IcRadioButtonEmpty24 } from '$assets';

export const SelectList: FC<SelectListProps> = ({
  value,
  options,
  description,
  onChange,
  multiple,
  chevron = false,
  iconSize,
  getIcon,
}) => {
  const handleChange = (optionValue: any) => {
    if (multiple) {
      if (value.includes(optionValue)) {
        onChange(value.filter((item) => item !== optionValue));
      } else {
        onChange([...value, optionValue]);
      }
    } else {
      onChange([optionValue]);
    }
  };

  return (
    <div className="SelectList">
      {!!description && <div className="SelectList__description">{description}</div>}
      <List>
        {options.map((option) => (
          <ListItem
            key={option.value}
            onClick={() => handleChange(option.value)}
            chevron={chevron}
            icon={
              value.includes(option.value) ? (
                <IcRadioButton24 />
              ) : multiple ? (
                <IcRadioButtonEmpty24 />
              ) : (
                <div className="SelectList__gap" />
              )
            }
            leftIconSize={iconSize}
            leftIcon={getIcon ? getIcon(option) : null}
            description={option.desc}
          >
            {option.label}
          </ListItem>
        ))}
      </List>
    </div>
  );
};
